import { ref } from 'vue';
import axios from 'axios';

const user = ref(null);

export const useAuth = () => {
    const getUser = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            user.value = null;
            return null;
        }

        const response = await axios.get('/api/auth/user', {
            headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.user) {
            user.value = response.data.user;
            return user.value;
        } else {
            localStorage.removeItem('token');
            user.value = null;
            return null;
        }
    };

    const login = async (email, password) => {
        const response = await axios.post('/api/auth/login', {
            email,
            password,
        });

        localStorage.setItem('token', response.data.token);
        user.value = response.data.user;
        return response.data;
    };

    const register = async (userData) => {
        const response = await axios.post('/api/auth/register', userData);
        localStorage.setItem('token', response.data.token);
        user.value = response.data.user;
        return response.data;
    };

    const logout = () => {
        localStorage.removeItem('token');
        user.value = null;
    };

    const isAuthenticated = () => !!user.value;

    return {
        user,
        getUser,
        login,
        register,
        logout,
        isAuthenticated,
    };
};
